module.exports = __webpack_public_path__ + "img/og.227e8bda.webp";